exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2hxYy{margin:0 auto}.j3uvV{-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center}._3z_b6{position:relative}.we5rd{width:calc(100% - 300px);margin-right:20px}._1YEEJ{margin-bottom:20px}.ERnjX{-webkit-box-flex:1;-ms-flex-positive:1;flex-grow:1}._1e7ed{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-orient:vertical;-webkit-box-direction:normal;-ms-flex-direction:column;flex-direction:column;width:300px}._3yKdv{margin-bottom:20px}", ""]);

// exports
exports.locals = {
	"page": "_19iU1 page",
	"container": "_2hxYy container",
	"flexRow": "j3uvV flexRow",
	"flexCell": "_3z_b6",
	"mainCell": "we5rd",
	"primary": "_1YEEJ",
	"flexGrow1": "ERnjX",
	"sideBar": "_1e7ed",
	"Juan": "_3yKdv"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"sourceMap":false,"modules":true,"localIdentName":"[hash:base64:5]","minimize":true,"discardComments":{"removeAll":true}}!./node_modules/postcss-loader/lib?{"config":{"path":"./tools/postcss.config.js"}}!./src/desktop/routes/journal/NewsComponent/NewsComponent.css
// module id = 3167
// module chunks = 16